<template>
  <!-- Modal -->
  <div
    class="modal"
    id="restore-shirt"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Restore Shirt</h3>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12 mb-10">
              <div class="icheck-danger">
                <input
                  type="checkbox"
                  name="restore_consultant_system"
                  value="1"
                  id="restoreConsultantSystemCheck"
                />
                <label for="restoreConsultantSystemCheck"
                  >Restore this Shirt in the Consultant System as well?</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            CANCEL
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ disabled: isProcessing }"
            @click="restoreShirt()"
          >
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isProcessing: false,
    };
  },
  methods: {
    restoreShirt() {
      this.isProcessing = true;
      let check = $("#restoreConsultantSystemCheck").is(":checked");
      this.$emit("submit", check);
    },
    resetModal() {
      this.isProcessing = false;
    },
  },
};
</script>
